import React,{ useState, useEffect} from "react";
import { Avatar, Menu, Dropdown } from "antd";
import GainIcon from "../gainicon";
import { useJwt } from "react-jwt";
import { getUser,toLogout } from "../../services/api"
import { baseURL } from "../../config"

const token = sessionStorage.getItem("token");

export default function NavHeader() {

  const { decodedToken, isExpired } = useJwt(token);


  const [User, setUser] = useState(null)


  useEffect(() => {
    user();
  }, [decodedToken])

  const user = async () => {
    if(decodedToken){
      const res = await getUser(decodedToken.data.id)
      setUser(res.data)
    }
  }

  const handleLogout = async () => {
    console.log(User.ID)
    const res = await toLogout({ID:User.ID})
    if(res.status === 200){
      sessionStorage.clear();
      window.location.replace("/login")
    }else{
      console.log(res.message)
    }
  }


  const menu = (
    <Menu className="rounded-xl">
      <Menu.Item key="1" className="text-center" onClick={handleLogout}>Logout</Menu.Item>
    </Menu>
  );

  return (
    <div className="float-right h-full px-6">
      <div className="flex w-full items-center">
        <Avatar src={`${baseURL}/api/images/${User?.profile}`} />
        <span className="px-3 ">{User?.firstname}</span>
        <Dropdown overlay={menu} trigger={["click"]} style={{top:10}} overlayClassName="-mt-24 w-36">
          <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
            <GainIcon name="arrow-down" />
          </a>
        </Dropdown>
      </div>
    </div>
  );
}
